import { render, staticRenderFns } from "./ItemsAbout.vue?vue&type=template&id=0d016039&scoped=true&lang=pug&"
import script from "./ItemsAbout.vue?vue&type=script&lang=ts&"
export * from "./ItemsAbout.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsAbout.vue?vue&type=style&index=0&id=0d016039&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d016039",
  null
  
)

export default component.exports